<template>
    <ul class="form_list">
        <li class="title">
            앱 예약 시간 간격
            <v-icon class="btn_tooltip">mdi-alert-circle-outline</v-icon>
            <span class="tooltip_wrap">
                <span class="tooltip">고객이 직접 예약을 할 때 선택할 수 있는 시간 간격을 의미합니다.</span>
            </span>
        </li>
        <li class="cont">
            <div class="form_list">
                <select class="input_s w_full"
                        :value="interval"
                        :disabled="!isActive || !usingDefaultAppInterval"
                        @change="updateValue('appInterval', Number($event.target.value))">
                    >
                    <option :value="5">5분</option>
                    <option :value="10">10분</option>
                    <option :value="15">15분</option>
                    <option :value="20">20분</option>
                    <option :value="25">25분</option>
                    <option :value="30">30분</option>
                    <option :value="35">35분</option>
                    <option :value="40">40분</option>
                    <option :value="45">45분</option>
                    <option :value="50">50분</option>
                    <option :value="55">55분</option>
                    <option :value="60">1시간</option>
                    <option :value="90">1시간30분</option>
                    <option :value="120">2시간</option>
                </select>
                <label class="check_wrap">
                    <input type="checkbox" v-model="isDirectSetting" :disabled="!isActive">
                    <span class="checkmark"></span>
                    직접선택
                </label>
            </div>

            <div class="table2_xyscroll sticky" style="height: 180px;" v-if="isDirectSetting">
                <table class="table2_default pd_small">
                    <thead>
                    <tr>
                        <th style="width: 220px;">시간 간격</th>
                        <th>삭제</th>
                    </tr>
                    </thead>
                    <tbody v-if="(appTimeIntervals?.length ?? 0) == 0">
                    <tr>
                        <td class="txt_center lgray_txt" colspan="2">기준을 추가해 주세요.</td>
                    </tr>
                    </tbody>
                    <tbody v-if="(appTimeIntervals?.length ?? 0) > 0">
                    <Item
                        v-for="(t, index) in appTimeIntervals" :key="index"
                        :value="t"
                        :index="index"
                        :isActive="isActive"
                        @updateItem="updateItem"
                        @removeItem="removeItem"
                    />
                    </tbody>
                    <tr>
                        <td class="txt_center" colspan="2">
                            <button class="btn btn_s btn_blue_line" @click="action_Add" :disabled="!isActive">＋ 추가</button>
                        </td>
                    </tr>
                </table>
            </div>
            <small class="red_txt" v-if="isErrorAppInterval">표시 기준을 최소 1개 이상 입력해 주세요.</small>
            <small class="red_txt" v-if="isErrorDuplicatedAppInterval">같은 시간으로 입력된 항목이 있습니다.</small>
        </li>
    </ul>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import Item from './Items/ReservationIntervalItem.vue'

export default {
    components: { Item },
    props: {
        isActive: Boolean,
        usingDefaultAppInterval: Boolean,
        appInterval: Number,
        appTimeIntervals: Array,

        isErrorAppInterval: Boolean,
        isErrorDuplicatedAppInterval: Boolean

    },
    data() {
        return {
            interval: 60,
            isDirectSetting: false
        }
    },
    watch: {
        usingDefaultAppInterval: {
            immediate: true,
            handler: function(newValue) {
                this.isDirectSetting = (newValue ?? true) == false
            }
        },
        appInterval: {
            immediate: true,
            handler: function(newValue) {
                this.interval = (newValue ?? 60)
            }
        },
        isDirectSetting: {
            handler: function(newValue, oldValue) {
                if (newValue == oldValue) {
                    return
                }
                this.clearError()
                this.updateValue('usingDefaultAppInterval', !newValue)
            }
        }
    },
    methods: {
        action_Add() {
            let intervals = deepCopy(this.appTimeIntervals)
            intervals.push('00:00')
            this.clearError()
            this.updateValue('appTimeIntervals', intervals)
        },
        updateItem(index, item) {
            let intervals = deepCopy(this.appTimeIntervals)
            intervals = intervals.slice(0, index)
                .concat([item])
                .concat(intervals.slice(index + 1))
            this.clearError()
            this.updateValue('appTimeIntervals', intervals)
        },
        removeItem(index) {
            let intervals = deepCopy(this.appTimeIntervals)
            intervals = intervals.splice(0, index).concat(intervals.slice(index + 1))
            this.clearError()
            this.updateValue('appTimeIntervals', intervals)
        },
        updateValue(key, value) {
            let data = {
                key: key,
                value: value
            }
            this.$emit('updateValue', data)
        },
        clearError() {
            this.$emit('clearError', 'isErrorAppInterval')
            this.$emit('clearError', 'isErrorDuplicatedAppInterval')
        }
    }
}
</script>